export { useGetTermsOfUseQuery } from './useGetTermsOfUseQuery';
